import { Sidebar } from "./sidebar/sidebar";
import { Header } from "./header/header";
import { useState, useEffect } from "react";

interface LayoutProps {
  children: React.ReactNode;
  title: string;
}

export function Layout({ children, title }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  
  // Detecta si es un dispositivo móvil al cargar y cuando cambia el tamaño de la ventana
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      // En dispositivos móviles, colapsar la barra lateral por defecto
      if (window.innerWidth < 768 && !sidebarCollapsed) {
        setSidebarCollapsed(true);
      }
    };
    
    // Verificar al montar el componente
    checkMobile();
    
    // Actualizar cuando cambie el tamaño de la ventana
    window.addEventListener('resize', checkMobile);
    
    // Limpiar el event listener al desmontar
    return () => window.removeEventListener('resize', checkMobile);
  }, [sidebarCollapsed]);

  
  const toggleSidebar = () => {
    if (isMobile) {
    setIsMobileOpen((prev) => !prev);
  } else {
    setSidebarCollapsed((prev) => !prev);
  }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#F1F5F9]">
      <div className={`flex-1 flex flex-col transition-all duration-300 w-full`}>
        {isMobile && (
          <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} isMobile={isMobile} isMobileOpen={isMobileOpen} setMobileOpen={setIsMobile}/>
        )}
        <Header toggleSidebar={toggleSidebar} title={title} isMobile={isMobile} />
        <main className="flex-1 overflow-y-auto bg-[#F1F5F9] p-2">
          {children}
        </main>
      </div>
    </div>
  );
}
